module.exports = __webpack_public_path__ + "img/01.9a4d2e24.png";